import { SignTitle } from '@/components'
import { Modal, Input, message, Form, Select } from 'antd'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useForm } from 'antd/es/form/Form'
import { useGetTaskBySite } from '@/pages/waf/task-list/utils'
import { t } from '@/i18n'

export const CompareModal = props => {
  const { data, setVisible } = props
  const navigate = useNavigate()
  const [form] = useForm()
  const [taskList, getTaskList] = useGetTaskBySite()

  useEffect(() => {
    getTaskList(data.site).catch(_ => {})
  }, [])

  const handleConfirm = values => {
    const { task } = values
    console.log('---', data.site, data.result_id, task)
    navigate('/validation/network/waf/comparison?tab=comparison', {
      state: {
        url: data.site,
        taskId: data.result_id,
        comTaskId: task,
      },
    })
  }
  const onCancel = () => {
    // setTextAreaValue(undefined)
    setVisible(false)
  }
  return (
    <Modal
      width="498px"
      title={
        <SignTitle show style={{ width: '498px' }}>
          {/*{templateDetail?.title || ''}*/}
          {t('任务对比')}
        </SignTitle>
      }
      // bodyStyle={{ width: '700px' }}
      centered
      // footer={null}
      onOk={form.submit}
      visible={data.visible}
      onCancel={onCancel}
      // bodyStyle={{ height: '318px', padding: 0 }}
    >
      <Form form={form} layout={'vertical'} onFinish={handleConfirm}>
        <Form.Item
          label={t('任务')}
          name={'task'}
          rules={[{ required: true, message: t('请选择任务') }]}
        >
          <Select placeholder={t('请选择任务')} showSearch optionFilterProp="label">
            {taskList?.map(item => (
              <Select.Option
                key={item.id}
                value={item.id}
                label={item.name}
                disabled={item.id === data.result_id}
              >
                {item.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  )
}
